/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IHostingEnvironmentSettingsClient {
    get(api_version: string | null): Observable<HostingEnvironmentSettings>;
    getHost(api_version: string | null): Observable<UrlResult>;
    dumpClaims(api_version: string | null): Observable<Claims>;
}

@Injectable()
export class HostingEnvironmentSettingsClient implements IHostingEnvironmentSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(api_version: string | null): Observable<HostingEnvironmentSettings> {
        let url_ = this.baseUrl + "/api/hostingenvironmentsettings?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HostingEnvironmentSettings>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostingEnvironmentSettings>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HostingEnvironmentSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostingEnvironmentSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostingEnvironmentSettings>(<any>null);
    }

    getHost(api_version: string | null): Observable<UrlResult> {
        let url_ = this.baseUrl + "/api/hostingenvironmentsettings/gethost?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHost(<any>response_);
                } catch (e) {
                    return <Observable<UrlResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<UrlResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetHost(response: HttpResponseBase): Observable<UrlResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UrlResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UrlResult>(<any>null);
    }

    dumpClaims(api_version: string | null): Observable<Claims> {
        let url_ = this.baseUrl + "/api/hostingenvironmentsettings/dumpclaims?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDumpClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDumpClaims(<any>response_);
                } catch (e) {
                    return <Observable<Claims>><any>_observableThrow(e);
                }
            } else
                return <Observable<Claims>><any>_observableThrow(response_);
        }));
    }

    protected processDumpClaims(response: HttpResponseBase): Observable<Claims> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Claims.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Claims>(<any>null);
    }
}

export interface IAttachmentDownloadClient {
    downloadAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null>;
}

@Injectable()
export class AttachmentDownloadClient implements IAttachmentDownloadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    downloadAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/attachmentdownload/{formId}/attachments/{name}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export interface IDataClient {
    /**
     * List the data for a form
     * @param formId Id of form
     * @param orderParamString (optional) sorting parameters in string format. Example:{"key":"business_unit","value":"descend"}
     * @param filterParamString (optional) search and filter parameters in string format. Example: {"ListQueryParams":[{"key":"business_unit","value":["FWD HK","FWD GO HK"]},{"key":"year","value":["2020","2019","2012"]}]}
     * @param pageIndex (optional) Index of page
     * @param statusFilter (optional) Status filter, possible values are "Created", "Submitted", "Approved", "Rejected", "Deleted"
     * @param searchText (optional) search text
     */
    list(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, filterParamString?: string | null | undefined, pageIndex?: string | null | undefined, statusFilter?: string | null | undefined, searchText?: string | null | undefined): Observable<ListDataVm>;
    getFormApprovers(formId: string | null, api_version: string | null, projectId?: string | null | undefined): Observable<FormApproverModel[]>;
    /**
     * List the deleted data for a form
     * @param formId Id of form
     * @param orderParamString (optional) 
     * @param pageIndex (optional) 
     */
    listDeleted(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, pageIndex?: string | null | undefined): Observable<ListDeletedDataVm>;
    /**
     * Batch submit/approve/reject the rows, update each row's status to Submitted/Approved/Rejected
     * @param formId Id of form
     * @param action (optional) Indicate which action is this command performed, possible values are Submit, Approve, Reject
     * @param dataId (optional) id for a record
     * @param comment (optional) Comment left by operator for the current action
     * @param mailTo (optional) Email Address to send
     * @param approverId (optional) Selected approver's id
     */
    workFlow(formId: string | null, api_version: string | null, action?: string | null | undefined, dataId?: string | null | undefined, comment?: string | null | undefined, mailTo?: string | null | undefined, approverId?: string | null | undefined): Observable<WorkFlowResultVM>;
    /**
     * Batch submit/approve/reject the rows, update each row's status to Submitted/Approved/Rejected
     * @param formId Id of form
     * @param dataIds List of guid for rows, comma separated
     * @param action (optional) Indicate which action is this command performed, possible values are Submit, Approve, Reject
     * @param comment (optional) Comment left by operator for the current action
     * @param mailTo (optional) Email Address to send
     * @param approverId (optional) Selected approver's id
     */
    batchWorkFlow(formId: string | null, dataIds: string, api_version: string | null, action?: string | null | undefined, comment?: string | null | undefined, mailTo?: string | null | undefined, approverId?: string | null | undefined): Observable<WorkFlowResultVM>;
    /**
     * Get form data by id
     * @param formId Id of form
     * @param id Guid of a record
     */
    getById(formId: string | null, id: string | null, api_version: string | null): Observable<GetByIdResponse>;
    /**
     * Update a form data record
     * @param formId Id of form
     * @param id Guid of data record
     * @param data Json data of form data
     * @param enforce (optional) True means to override the existing data
     * @param updateSubmit (optional) Update and Submit
     */
    update(formId: string | null, id: string | null, data: any, api_version: string | null, enforce?: boolean | undefined, updateSubmit?: boolean | undefined): Observable<UpsertResponse>;
    /**
     * Delete a record, or a bacth of records
     * @param formId Id of form
     * @param id Id for this record
     */
    delete(formId: string | null, id: string | null, api_version: string | null): Observable<DeleteDataVm>;
    /**
     * Create a form data record
     * @param formId Id of form
     * @param data Jason data of form data
     * @param enforce (optional) True means to override the existing data
     * @param saveSubmit (optional) Save and Submit
     */
    create(formId: string | null, data: any, api_version: string | null, enforce?: boolean | undefined, saveSubmit?: boolean | undefined): Observable<CreateResponse>;
    /**
     * Delete a record, or a bacth of records
     * @param formId Id of form
     * @param ids Comma separated guid list
     */
    batchDelete(formId: string | null, ids: string, api_version: string | null): Observable<BatchDeleteDataVm>;
    uploadAttachment(formId: string | null, api_version: string | null, file?: FileParameter | null | undefined): Observable<string>;
    downloadAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null>;
    deleteAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null>;
    downloadTemplate(formId: string | null, api_version: string | null): Observable<FileResponse | null>;
    auditTrail(formId: string | null, api_version: string | null, dataId?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, action?: string | null | undefined, orderParamString?: string | null | undefined, pageIndex?: string | null | undefined): Observable<ListAuditDataVm>;
    /**
     * Upload excel/csv data to database, and upload it to Azure blob container when import id is needed
     * @param formId Id of form
     * @param file (optional) File to upload data
     * @param enforce (optional) True means to override the existing data
     * @return ImportRequestResultVM
     */
    upload(formId: string | null, api_version: string | null, file?: FileParameter | null | undefined, enforce?: boolean | undefined): Observable<ImportRequestResultVM>;
    /**
     * Upload excel/csv data to database, and upload it to Azure blob container when import id is needed
     * @param base64Data Upload data
     * @param enforce (optional) True means to override the existing data
     * @return ImportRequestResultVM
     */
    uploadBase64(base64Data: UploadBase64, api_version: string | null, enforce?: boolean | undefined): Observable<ImportRequestResultVM>;
    /**
     * Export data to excel
     * @param formId Id of form
     * @param orderParamString (optional) sorting parameters in string format. Example:{"key":"business_unit","value":"descend"}
     * @param filterParamString (optional) search and filter parameters in string format. Example: {"ListQueryParams":[{"key":"business_unit","value":["FWD HK","FWD GO HK"]},{"key":"year","value":["2020","2019","2012"]}]}
     * @param pageIndex (optional) Index of page
     * @param statusFilter (optional) Status filter, possible values are "Created", "Submitted", "Approved", "Rejected", "Deleted"
     * @param searchText (optional) search text
     */
    exportData(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, filterParamString?: string | null | undefined, pageIndex?: string | null | undefined, statusFilter?: string | null | undefined, searchText?: string | null | undefined): Observable<FileResponse | null>;
    addDataComment(request: AddDataCommentRequest, api_version: string | null): Observable<AddDataCommentVM>;
}

@Injectable()
export class DataClient implements IDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * List the data for a form
     * @param formId Id of form
     * @param orderParamString (optional) sorting parameters in string format. Example:{"key":"business_unit","value":"descend"}
     * @param filterParamString (optional) search and filter parameters in string format. Example: {"ListQueryParams":[{"key":"business_unit","value":["FWD HK","FWD GO HK"]},{"key":"year","value":["2020","2019","2012"]}]}
     * @param pageIndex (optional) Index of page
     * @param statusFilter (optional) Status filter, possible values are "Created", "Submitted", "Approved", "Rejected", "Deleted"
     * @param searchText (optional) search text
     */
    list(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, filterParamString?: string | null | undefined, pageIndex?: string | null | undefined, statusFilter?: string | null | undefined, searchText?: string | null | undefined): Observable<ListDataVm> {
        let url_ = this.baseUrl + "/api/data/list/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (orderParamString !== undefined && orderParamString !== null)
            url_ += "orderParamString=" + encodeURIComponent("" + orderParamString) + "&";
        if (filterParamString !== undefined && filterParamString !== null)
            url_ += "filterParamString=" + encodeURIComponent("" + filterParamString) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(<any>response_);
                } catch (e) {
                    return <Observable<ListDataVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListDataVm>><any>_observableThrow(response_);
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListDataVm>(<any>null);
    }

    getFormApprovers(formId: string | null, api_version: string | null, projectId?: string | null | undefined): Observable<FormApproverModel[]> {
        let url_ = this.baseUrl + "/api/data/{formId}/approvers?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormApprovers(<any>response_);
                } catch (e) {
                    return <Observable<FormApproverModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormApproverModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormApprovers(response: HttpResponseBase): Observable<FormApproverModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormApproverModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormApproverModel[]>(<any>null);
    }

    /**
     * List the deleted data for a form
     * @param formId Id of form
     * @param orderParamString (optional) 
     * @param pageIndex (optional) 
     */
    listDeleted(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, pageIndex?: string | null | undefined): Observable<ListDeletedDataVm> {
        let url_ = this.baseUrl + "/api/data/listdeleted/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (orderParamString !== undefined && orderParamString !== null)
            url_ += "orderParamString=" + encodeURIComponent("" + orderParamString) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDeleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDeleted(<any>response_);
                } catch (e) {
                    return <Observable<ListDeletedDataVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListDeletedDataVm>><any>_observableThrow(response_);
        }));
    }

    protected processListDeleted(response: HttpResponseBase): Observable<ListDeletedDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDeletedDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListDeletedDataVm>(<any>null);
    }

    /**
     * Batch submit/approve/reject the rows, update each row's status to Submitted/Approved/Rejected
     * @param formId Id of form
     * @param action (optional) Indicate which action is this command performed, possible values are Submit, Approve, Reject
     * @param dataId (optional) id for a record
     * @param comment (optional) Comment left by operator for the current action
     * @param mailTo (optional) Email Address to send
     * @param approverId (optional) Selected approver's id
     */
    workFlow(formId: string | null, api_version: string | null, action?: string | null | undefined, dataId?: string | null | undefined, comment?: string | null | undefined, mailTo?: string | null | undefined, approverId?: string | null | undefined): Observable<WorkFlowResultVM> {
        let url_ = this.baseUrl + "/api/data/workflow/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (dataId !== undefined && dataId !== null)
            url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (mailTo !== undefined && mailTo !== null)
            url_ += "mailTo=" + encodeURIComponent("" + mailTo) + "&";
        if (approverId !== undefined && approverId !== null)
            url_ += "approverId=" + encodeURIComponent("" + approverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkFlow(<any>response_);
                } catch (e) {
                    return <Observable<WorkFlowResultVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkFlowResultVM>><any>_observableThrow(response_);
        }));
    }

    protected processWorkFlow(response: HttpResponseBase): Observable<WorkFlowResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFlowResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkFlowResultVM>(<any>null);
    }

    /**
     * Batch submit/approve/reject the rows, update each row's status to Submitted/Approved/Rejected
     * @param formId Id of form
     * @param dataIds List of guid for rows, comma separated
     * @param action (optional) Indicate which action is this command performed, possible values are Submit, Approve, Reject
     * @param comment (optional) Comment left by operator for the current action
     * @param mailTo (optional) Email Address to send
     * @param approverId (optional) Selected approver's id
     */
    batchWorkFlow(formId: string | null, dataIds: string, api_version: string | null, action?: string | null | undefined, comment?: string | null | undefined, mailTo?: string | null | undefined, approverId?: string | null | undefined): Observable<WorkFlowResultVM> {
        let url_ = this.baseUrl + "/api/data/batchworkflow/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (mailTo !== undefined && mailTo !== null)
            url_ += "mailTo=" + encodeURIComponent("" + mailTo) + "&";
        if (approverId !== undefined && approverId !== null)
            url_ += "approverId=" + encodeURIComponent("" + approverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchWorkFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchWorkFlow(<any>response_);
                } catch (e) {
                    return <Observable<WorkFlowResultVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<WorkFlowResultVM>><any>_observableThrow(response_);
        }));
    }

    protected processBatchWorkFlow(response: HttpResponseBase): Observable<WorkFlowResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFlowResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkFlowResultVM>(<any>null);
    }

    /**
     * Get form data by id
     * @param formId Id of form
     * @param id Guid of a record
     */
    getById(formId: string | null, id: string | null, api_version: string | null): Observable<GetByIdResponse> {
        let url_ = this.baseUrl + "/api/data/{formId}/{id}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GetByIdResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetByIdResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetByIdResponse>(<any>null);
    }

    /**
     * Update a form data record
     * @param formId Id of form
     * @param id Guid of data record
     * @param data Json data of form data
     * @param enforce (optional) True means to override the existing data
     * @param updateSubmit (optional) Update and Submit
     */
    update(formId: string | null, id: string | null, data: any, api_version: string | null, enforce?: boolean | undefined, updateSubmit?: boolean | undefined): Observable<UpsertResponse> {
        let url_ = this.baseUrl + "/api/data/{formId}/{id}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (enforce === null)
            throw new Error("The parameter 'enforce' cannot be null.");
        else if (enforce !== undefined)
            url_ += "enforce=" + encodeURIComponent("" + enforce) + "&";
        if (updateSubmit === null)
            throw new Error("The parameter 'updateSubmit' cannot be null.");
        else if (updateSubmit !== undefined)
            url_ += "updateSubmit=" + encodeURIComponent("" + updateSubmit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UpsertResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpsertResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertResponse>(<any>null);
    }

    /**
     * Delete a record, or a bacth of records
     * @param formId Id of form
     * @param id Id for this record
     */
    delete(formId: string | null, id: string | null, api_version: string | null): Observable<DeleteDataVm> {
        let url_ = this.baseUrl + "/api/data/{formId}/{id}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<DeleteDataVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeleteDataVm>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteDataVm>(<any>null);
    }

    /**
     * Create a form data record
     * @param formId Id of form
     * @param data Jason data of form data
     * @param enforce (optional) True means to override the existing data
     * @param saveSubmit (optional) Save and Submit
     */
    create(formId: string | null, data: any, api_version: string | null, enforce?: boolean | undefined, saveSubmit?: boolean | undefined): Observable<CreateResponse> {
        let url_ = this.baseUrl + "/api/data/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (enforce === null)
            throw new Error("The parameter 'enforce' cannot be null.");
        else if (enforce !== undefined)
            url_ += "enforce=" + encodeURIComponent("" + enforce) + "&";
        if (saveSubmit === null)
            throw new Error("The parameter 'saveSubmit' cannot be null.");
        else if (saveSubmit !== undefined)
            url_ += "saveSubmit=" + encodeURIComponent("" + saveSubmit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CreateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateResponse>(<any>null);
    }

    /**
     * Delete a record, or a bacth of records
     * @param formId Id of form
     * @param ids Comma separated guid list
     */
    batchDelete(formId: string | null, ids: string, api_version: string | null): Observable<BatchDeleteDataVm> {
        let url_ = this.baseUrl + "/api/data/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<BatchDeleteDataVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchDeleteDataVm>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<BatchDeleteDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchDeleteDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchDeleteDataVm>(<any>null);
    }

    uploadAttachment(formId: string | null, api_version: string | null, file?: FileParameter | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/data/{formId}/attachments/create?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    downloadAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/data/{formId}/attachments/{name}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    deleteAttachment(formId: string | null, name: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/data/{formId}/attachments/{name}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    downloadTemplate(formId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/data/{formId}/template?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTemplate(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadTemplate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    auditTrail(formId: string | null, api_version: string | null, dataId?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, action?: string | null | undefined, orderParamString?: string | null | undefined, pageIndex?: string | null | undefined): Observable<ListAuditDataVm> {
        let url_ = this.baseUrl + "/api/data/audittrail/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (dataId !== undefined && dataId !== null)
            url_ += "dataId=" + encodeURIComponent("" + dataId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (action !== undefined && action !== null)
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (orderParamString !== undefined && orderParamString !== null)
            url_ += "orderParamString=" + encodeURIComponent("" + orderParamString) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditTrail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditTrail(<any>response_);
                } catch (e) {
                    return <Observable<ListAuditDataVm>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListAuditDataVm>><any>_observableThrow(response_);
        }));
    }

    protected processAuditTrail(response: HttpResponseBase): Observable<ListAuditDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListAuditDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListAuditDataVm>(<any>null);
    }

    /**
     * Upload excel/csv data to database, and upload it to Azure blob container when import id is needed
     * @param formId Id of form
     * @param file (optional) File to upload data
     * @param enforce (optional) True means to override the existing data
     * @return ImportRequestResultVM
     */
    upload(formId: string | null, api_version: string | null, file?: FileParameter | null | undefined, enforce?: boolean | undefined): Observable<ImportRequestResultVM> {
        let url_ = this.baseUrl + "/api/data/import/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (enforce === null)
            throw new Error("The parameter 'enforce' cannot be null.");
        else if (enforce !== undefined)
            url_ += "enforce=" + encodeURIComponent("" + enforce) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<ImportRequestResultVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportRequestResultVM>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<ImportRequestResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportRequestResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportRequestResultVM>(<any>null);
    }

    /**
     * Upload excel/csv data to database, and upload it to Azure blob container when import id is needed
     * @param base64Data Upload data
     * @param enforce (optional) True means to override the existing data
     * @return ImportRequestResultVM
     */
    uploadBase64(base64Data: UploadBase64, api_version: string | null, enforce?: boolean | undefined): Observable<ImportRequestResultVM> {
        let url_ = this.baseUrl + "/api/data/import64?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (enforce === null)
            throw new Error("The parameter 'enforce' cannot be null.");
        else if (enforce !== undefined)
            url_ += "enforce=" + encodeURIComponent("" + enforce) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64Data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBase64(<any>response_);
                } catch (e) {
                    return <Observable<ImportRequestResultVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportRequestResultVM>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBase64(response: HttpResponseBase): Observable<ImportRequestResultVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportRequestResultVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportRequestResultVM>(<any>null);
    }

    /**
     * Export data to excel
     * @param formId Id of form
     * @param orderParamString (optional) sorting parameters in string format. Example:{"key":"business_unit","value":"descend"}
     * @param filterParamString (optional) search and filter parameters in string format. Example: {"ListQueryParams":[{"key":"business_unit","value":["FWD HK","FWD GO HK"]},{"key":"year","value":["2020","2019","2012"]}]}
     * @param pageIndex (optional) Index of page
     * @param statusFilter (optional) Status filter, possible values are "Created", "Submitted", "Approved", "Rejected", "Deleted"
     * @param searchText (optional) search text
     */
    exportData(formId: string | null, api_version: string | null, orderParamString?: string | null | undefined, filterParamString?: string | null | undefined, pageIndex?: string | null | undefined, statusFilter?: string | null | undefined, searchText?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/data/export/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (orderParamString !== undefined && orderParamString !== null)
            url_ += "orderParamString=" + encodeURIComponent("" + orderParamString) + "&";
        if (filterParamString !== undefined && filterParamString !== null)
            url_ += "filterParamString=" + encodeURIComponent("" + filterParamString) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (statusFilter !== undefined && statusFilter !== null)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportData(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processExportData(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    addDataComment(request: AddDataCommentRequest, api_version: string | null): Observable<AddDataCommentVM> {
        let url_ = this.baseUrl + "/api/data/comments?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDataComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDataComment(<any>response_);
                } catch (e) {
                    return <Observable<AddDataCommentVM>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddDataCommentVM>><any>_observableThrow(response_);
        }));
    }

    protected processAddDataComment(response: HttpResponseBase): Observable<AddDataCommentVM> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddDataCommentVM.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddDataCommentVM>(<any>null);
    }
}

export interface IIdentityClient {
    getAADUsers(api_version: string | null, searchText?: string | null | undefined): Observable<AadUserModel[]>;
    callGraphApiOnBehalfOfUser(api_version: string | null, searchText?: string | null | undefined): Observable<AadUserModel[]>;
}

@Injectable()
export class IdentityClient implements IIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAADUsers(api_version: string | null, searchText?: string | null | undefined): Observable<AadUserModel[]> {
        let url_ = this.baseUrl + "/api/identity/aadusers?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAADUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAADUsers(<any>response_);
                } catch (e) {
                    return <Observable<AadUserModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AadUserModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAADUsers(response: HttpResponseBase): Observable<AadUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AadUserModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AadUserModel[]>(<any>null);
    }

    callGraphApiOnBehalfOfUser(api_version: string | null, searchText?: string | null | undefined): Observable<AadUserModel[]> {
        let url_ = this.baseUrl + "/api/identity?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallGraphApiOnBehalfOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallGraphApiOnBehalfOfUser(<any>response_);
                } catch (e) {
                    return <Observable<AadUserModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AadUserModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processCallGraphApiOnBehalfOfUser(response: HttpResponseBase): Observable<AadUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AadUserModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AadUserModel[]>(<any>null);
    }
}

export interface IPermissionClient {
    getSubjectPermissions(api_version: string | null, subjectId?: string | null | undefined): Observable<string>;
}

@Injectable()
export class PermissionClient implements IPermissionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSubjectPermissions(api_version: string | null, subjectId?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/permission?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (subjectId !== undefined && subjectId !== null)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubjectPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubjectPermissions(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubjectPermissions(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface IProjectsClient {
    getUserAdminedProjects(api_version: string | null): Observable<ProjectModel[]>;
    getById(id: string | null, api_version: string | null): Observable<ProjectModel>;
    upsertProject(id: string | null, model: ProjectModel, api_version: string | null): Observable<ProjectModel>;
    deleteProject(id: string | null, api_version: string | null): Observable<FileResponse | null>;
    getAdministrators(id: string | null, api_version: string | null): Observable<ProjectAdministratorModel[]>;
    addAdministrators(id: string | null, userIds: string[], api_version: string | null): Observable<FileResponse | null>;
    removeAdministrator(id: string | null, uid: string | null, api_version: string | null): Observable<FileResponse | null>;
    getForms(id: string | null, api_version: string | null): Observable<ProjectFormModel[]>;
    addForm(id: string | null, formId: string | null, api_version: string | null): Observable<FileResponse | null>;
    removeForm(id: string | null, formId: string | null, api_version: string | null): Observable<FileResponse | null>;
    getAddibleFormGroups(id: string | null, api_version: string | null): Observable<ProjectFormModel[]>;
    addFormGroup(id: string | null, formGroupId: string | null, api_version: string | null): Observable<FileResponse | null>;
    removeFormGroup(id: string | null, formGroupId: string | null, api_version: string | null): Observable<FileResponse | null>;
    getUserGroups(id: string | null, api_version: string | null): Observable<ProjectUserGroupModel[]>;
    upsertUserGroup(id: string | null, userGroup: ProjectUserGroupModel, api_version: string | null): Observable<FileResponse | null>;
    getUserGroup(id: string | null, userGroupId: string | null, api_version: string | null): Observable<ProjectUserGroupModel>;
    removeUserGroup(id: string | null, userGroupId: string | null, api_version: string | null): Observable<FileResponse | null>;
    getUserGroupsByUser(id: string | null, userId: string | null, api_version: string | null): Observable<ProjectUserGroupModel[]>;
    addUserGroupMembers(id: string | null, userGroupId: string | null, subjects: SubjectModel[], api_version: string | null): Observable<FileResponse | null>;
    removeUserGroupMembers(id: string | null, userGroupId: string | null, subjects: SubjectModel[], api_version: string | null): Observable<FileResponse | null>;
    getDataPermissions(id: string | null, userGroupId: string | null, api_version: string | null): Observable<DataPermissionModel[]>;
    addDataPermission(id: string | null, userGroupId: string | null, permission: DataPermissionModel, api_version: string | null): Observable<FileResponse | null>;
    removeDataPermission(id: string | null, userGroupId: string | null, permission: DataPermissionModel, api_version: string | null): Observable<FileResponse | null>;
    updateDataPermissions(id: string | null, userGroupId: string | null, request: UpdateDataPermissionsRequest, api_version: string | null): Observable<FileResponse | null>;
    getUsers(id: string | null, api_version: string | null): Observable<ProjectUserModel[]>;
    getProjectUserPermissionAuditTrail(id: string | null, api_version: string | null, startDate?: Date | null | undefined, endDate?: Date | null | undefined, pageIndex?: string | null | undefined): Observable<ProjectUserPermissionAuditTrailResponse>;
    getAllTimeZones(api_version: string | null): Observable<TimeZoneModel[]>;
}

@Injectable()
export class ProjectsClient implements IProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserAdminedProjects(api_version: string | null): Observable<ProjectModel[]> {
        let url_ = this.baseUrl + "/api/projects?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAdminedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAdminedProjects(<any>response_);
                } catch (e) {
                    return <Observable<ProjectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAdminedProjects(response: HttpResponseBase): Observable<ProjectModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectModel[]>(<any>null);
    }

    getById(id: string | null, api_version: string | null): Observable<ProjectModel> {
        let url_ = this.baseUrl + "/api/projects/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<ProjectModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ProjectModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectModel>(<any>null);
    }

    upsertProject(id: string | null, model: ProjectModel, api_version: string | null): Observable<ProjectModel> {
        let url_ = this.baseUrl + "/api/projects/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertProject(<any>response_);
                } catch (e) {
                    return <Observable<ProjectModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertProject(response: HttpResponseBase): Observable<ProjectModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectModel>(<any>null);
    }

    deleteProject(id: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getAdministrators(id: string | null, api_version: string | null): Observable<ProjectAdministratorModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/administrators?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdministrators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdministrators(<any>response_);
                } catch (e) {
                    return <Observable<ProjectAdministratorModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectAdministratorModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdministrators(response: HttpResponseBase): Observable<ProjectAdministratorModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectAdministratorModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectAdministratorModel[]>(<any>null);
    }

    addAdministrators(id: string | null, userIds: string[], api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/administrators?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAdministrators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAdministrators(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddAdministrators(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    removeAdministrator(id: string | null, uid: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/administrators/{uid}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAdministrator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAdministrator(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveAdministrator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getForms(id: string | null, api_version: string | null): Observable<ProjectFormModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/forms?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForms(<any>response_);
                } catch (e) {
                    return <Observable<ProjectFormModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectFormModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetForms(response: HttpResponseBase): Observable<ProjectFormModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFormModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFormModel[]>(<any>null);
    }

    addForm(id: string | null, formId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/forms/{formId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddForm(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddForm(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    removeForm(id: string | null, formId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/forms/{formId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveForm(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveForm(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getAddibleFormGroups(id: string | null, api_version: string | null): Observable<ProjectFormModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/formgroups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddibleFormGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddibleFormGroups(<any>response_);
                } catch (e) {
                    return <Observable<ProjectFormModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectFormModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddibleFormGroups(response: HttpResponseBase): Observable<ProjectFormModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFormModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectFormModel[]>(<any>null);
    }

    addFormGroup(id: string | null, formGroupId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/formgroups/{formGroupId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formGroupId === undefined || formGroupId === null)
            throw new Error("The parameter 'formGroupId' must be defined.");
        url_ = url_.replace("{formGroupId}", encodeURIComponent("" + formGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFormGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFormGroup(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddFormGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    removeFormGroup(id: string | null, formGroupId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/formgroups/{formGroupId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formGroupId === undefined || formGroupId === null)
            throw new Error("The parameter 'formGroupId' must be defined.");
        url_ = url_.replace("{formGroupId}", encodeURIComponent("" + formGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFormGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFormGroup(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveFormGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getUserGroups(id: string | null, api_version: string | null): Observable<ProjectUserGroupModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserGroups(<any>response_);
                } catch (e) {
                    return <Observable<ProjectUserGroupModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectUserGroupModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserGroups(response: HttpResponseBase): Observable<ProjectUserGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectUserGroupModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUserGroupModel[]>(<any>null);
    }

    upsertUserGroup(id: string | null, userGroup: ProjectUserGroupModel, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userGroup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertUserGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertUserGroup(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertUserGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getUserGroup(id: string | null, userGroupId: string | null, api_version: string | null): Observable<ProjectUserGroupModel> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserGroup(<any>response_);
                } catch (e) {
                    return <Observable<ProjectUserGroupModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectUserGroupModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserGroup(response: HttpResponseBase): Observable<ProjectUserGroupModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUserGroupModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUserGroupModel>(<any>null);
    }

    removeUserGroup(id: string | null, userGroupId: string | null, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserGroup(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserGroup(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getUserGroupsByUser(id: string | null, userId: string | null, api_version: string | null): Observable<ProjectUserGroupModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/users/{userId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserGroupsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserGroupsByUser(<any>response_);
                } catch (e) {
                    return <Observable<ProjectUserGroupModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectUserGroupModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserGroupsByUser(response: HttpResponseBase): Observable<ProjectUserGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectUserGroupModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUserGroupModel[]>(<any>null);
    }

    addUserGroupMembers(id: string | null, userGroupId: string | null, subjects: SubjectModel[], api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/members?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subjects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserGroupMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserGroupMembers(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddUserGroupMembers(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    removeUserGroupMembers(id: string | null, userGroupId: string | null, subjects: SubjectModel[], api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/members?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subjects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserGroupMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserGroupMembers(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserGroupMembers(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getDataPermissions(id: string | null, userGroupId: string | null, api_version: string | null): Observable<DataPermissionModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/permissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataPermissions(<any>response_);
                } catch (e) {
                    return <Observable<DataPermissionModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DataPermissionModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDataPermissions(response: HttpResponseBase): Observable<DataPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataPermissionModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataPermissionModel[]>(<any>null);
    }

    addDataPermission(id: string | null, userGroupId: string | null, permission: DataPermissionModel, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/permissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDataPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDataPermission(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAddDataPermission(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    removeDataPermission(id: string | null, userGroupId: string | null, permission: DataPermissionModel, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/permissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDataPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDataPermission(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDataPermission(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    updateDataPermissions(id: string | null, userGroupId: string | null, request: UpdateDataPermissionsRequest, api_version: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{id}/groups/{userGroupId}/update-permissions?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDataPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDataPermissions(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDataPermissions(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getUsers(id: string | null, api_version: string | null): Observable<ProjectUserModel[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<ProjectUserModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectUserModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<ProjectUserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectUserModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUserModel[]>(<any>null);
    }

    getProjectUserPermissionAuditTrail(id: string | null, api_version: string | null, startDate?: Date | null | undefined, endDate?: Date | null | undefined, pageIndex?: string | null | undefined): Observable<ProjectUserPermissionAuditTrailResponse> {
        let url_ = this.baseUrl + "/api/projects/{id}/user-permission-audit-trail?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectUserPermissionAuditTrail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectUserPermissionAuditTrail(<any>response_);
                } catch (e) {
                    return <Observable<ProjectUserPermissionAuditTrailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectUserPermissionAuditTrailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetProjectUserPermissionAuditTrail(response: HttpResponseBase): Observable<ProjectUserPermissionAuditTrailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectUserPermissionAuditTrailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectUserPermissionAuditTrailResponse>(<any>null);
    }

    getAllTimeZones(api_version: string | null): Observable<TimeZoneModel[]> {
        let url_ = this.baseUrl + "/api/projects/timezones?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTimeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTimeZones(<any>response_);
                } catch (e) {
                    return <Observable<TimeZoneModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TimeZoneModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTimeZones(response: HttpResponseBase): Observable<TimeZoneModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZoneModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeZoneModel[]>(<any>null);
    }
}

export interface ISchemaClient {
    /**
     * Get the list of Form that the currently user has access to. The response put Form
    into related FormGroup.
     */
    listFormGroups(api_version: string | null): Observable<ListFormGroupsResponse>;
    /**
     * Get the configuration/schema of a Form
     * @param formId The ID of the Form
     * @return GetFormByIdResponse
     */
    getForm(formId: string | null, api_version: string | null): Observable<GetFormByIdResponse>;
    deleteForm(formId: string | null, api_version: string | null): Observable<DeleteFormResponse>;
    upsertForm(model: FormModel, api_version: string | null): Observable<UpsertFormResponse>;
    updateFormDetails(formId: string | null, details: FormDetailsModel, api_version: string | null): Observable<UpdateFormResponse>;
    getFormDataScopes(formId: string | null, api_version: string | null): Observable<FormDataScopeModel[]>;
    upsertFormDataScope(formId: string | null, model: FormDataScopeModel, api_version: string | null): Observable<FormDataScopeModel[]>;
    deleteFormDataScope(formId: string | null, dataScopeId: string | null, api_version: string | null): Observable<DeleteFormResponse>;
}

@Injectable()
export class SchemaClient implements ISchemaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the list of Form that the currently user has access to. The response put Form
    into related FormGroup.
     */
    listFormGroups(api_version: string | null): Observable<ListFormGroupsResponse> {
        let url_ = this.baseUrl + "/api/schema/fgs?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListFormGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListFormGroups(<any>response_);
                } catch (e) {
                    return <Observable<ListFormGroupsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListFormGroupsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processListFormGroups(response: HttpResponseBase): Observable<ListFormGroupsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListFormGroupsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListFormGroupsResponse>(<any>null);
    }

    /**
     * Get the configuration/schema of a Form
     * @param formId The ID of the Form
     * @return GetFormByIdResponse
     */
    getForm(formId: string | null, api_version: string | null): Observable<GetFormByIdResponse> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForm(<any>response_);
                } catch (e) {
                    return <Observable<GetFormByIdResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFormByIdResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetForm(response: HttpResponseBase): Observable<GetFormByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFormByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormByIdResponse>(<any>null);
    }

    deleteForm(formId: string | null, api_version: string | null): Observable<DeleteFormResponse> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForm(<any>response_);
                } catch (e) {
                    return <Observable<DeleteFormResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeleteFormResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteForm(response: HttpResponseBase): Observable<DeleteFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFormResponse>(<any>null);
    }

    upsertForm(model: FormModel, api_version: string | null): Observable<UpsertFormResponse> {
        let url_ = this.baseUrl + "/api/schema/f?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertForm(<any>response_);
                } catch (e) {
                    return <Observable<UpsertFormResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpsertFormResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertForm(response: HttpResponseBase): Observable<UpsertFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpsertFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpsertFormResponse>(<any>null);
    }

    updateFormDetails(formId: string | null, details: FormDetailsModel, api_version: string | null): Observable<UpdateFormResponse> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}/details?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFormDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFormDetails(<any>response_);
                } catch (e) {
                    return <Observable<UpdateFormResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateFormResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFormDetails(response: HttpResponseBase): Observable<UpdateFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFormResponse>(<any>null);
    }

    getFormDataScopes(formId: string | null, api_version: string | null): Observable<FormDataScopeModel[]> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}/ds?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormDataScopes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormDataScopes(<any>response_);
                } catch (e) {
                    return <Observable<FormDataScopeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDataScopeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormDataScopes(response: HttpResponseBase): Observable<FormDataScopeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormDataScopeModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDataScopeModel[]>(<any>null);
    }

    upsertFormDataScope(formId: string | null, model: FormDataScopeModel, api_version: string | null): Observable<FormDataScopeModel[]> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}/ds?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertFormDataScope(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertFormDataScope(<any>response_);
                } catch (e) {
                    return <Observable<FormDataScopeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDataScopeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertFormDataScope(response: HttpResponseBase): Observable<FormDataScopeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormDataScopeModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDataScopeModel[]>(<any>null);
    }

    deleteFormDataScope(formId: string | null, dataScopeId: string | null, api_version: string | null): Observable<DeleteFormResponse> {
        let url_ = this.baseUrl + "/api/schema/f/{formId}/ds/{dataScopeId}?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (dataScopeId === undefined || dataScopeId === null)
            throw new Error("The parameter 'dataScopeId' must be defined.");
        url_ = url_.replace("{dataScopeId}", encodeURIComponent("" + dataScopeId));
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFormDataScope(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFormDataScope(<any>response_);
                } catch (e) {
                    return <Observable<DeleteFormResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeleteFormResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteFormDataScope(response: HttpResponseBase): Observable<DeleteFormResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFormResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFormResponse>(<any>null);
    }
}

export interface IUserGroupClient {
    get(api_version: string | null): Observable<string>;
}

@Injectable()
export class UserGroupClient implements IUserGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(api_version: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/usergroup?";
        if (api_version === undefined)
            throw new Error("The parameter 'api_version' must be defined.");
        else if(api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export class HostingEnvironmentSettings implements IHostingEnvironmentSettings {
    spaClientId?: string | undefined;
    spaTenantId?: string | undefined;
    spaWebApiScope?: string | undefined;
    spaRedirectUri?: string | undefined;
    spaPostLogoutRedirectUri?: string | undefined;
    applicationInsightsKey?: string | undefined;

    constructor(data?: IHostingEnvironmentSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaClientId = _data["spaClientId"];
            this.spaTenantId = _data["spaTenantId"];
            this.spaWebApiScope = _data["spaWebApiScope"];
            this.spaRedirectUri = _data["spaRedirectUri"];
            this.spaPostLogoutRedirectUri = _data["spaPostLogoutRedirectUri"];
            this.applicationInsightsKey = _data["applicationInsightsKey"];
        }
    }

    static fromJS(data: any): HostingEnvironmentSettings {
        data = typeof data === 'object' ? data : {};
        let result = new HostingEnvironmentSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaClientId"] = this.spaClientId;
        data["spaTenantId"] = this.spaTenantId;
        data["spaWebApiScope"] = this.spaWebApiScope;
        data["spaRedirectUri"] = this.spaRedirectUri;
        data["spaPostLogoutRedirectUri"] = this.spaPostLogoutRedirectUri;
        data["applicationInsightsKey"] = this.applicationInsightsKey;
        return data; 
    }
}

export interface IHostingEnvironmentSettings {
    spaClientId?: string | undefined;
    spaTenantId?: string | undefined;
    spaWebApiScope?: string | undefined;
    spaRedirectUri?: string | undefined;
    spaPostLogoutRedirectUri?: string | undefined;
    applicationInsightsKey?: string | undefined;
}

export class UrlResult implements IUrlResult {
    url?: string | undefined;

    constructor(data?: IUrlResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): UrlResult {
        data = typeof data === 'object' ? data : {};
        let result = new UrlResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }
}

export interface IUrlResult {
    url?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class Claims implements IClaims {
    value?: Claim[] | undefined;

    constructor(data?: IClaims) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(Claim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Claims {
        data = typeof data === 'object' ? data : {};
        let result = new Claims();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IClaims {
    value?: Claim[] | undefined;
}

export class Claim implements IClaim {
    issuer?: string | undefined;
    originalIssuer?: string | undefined;
    properties?: { [key: string]: string; } | undefined;
    type?: string | undefined;
    value?: string | undefined;
    valueType?: string | undefined;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties![key] = _data["properties"][key];
                }
            }
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data; 
    }
}

export interface IClaim {
    issuer?: string | undefined;
    originalIssuer?: string | undefined;
    properties?: { [key: string]: string; } | undefined;
    type?: string | undefined;
    value?: string | undefined;
    valueType?: string | undefined;
}

export class ListDataVm implements IListDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    totalPage!: number;
    totalRecords!: number;
    pageSize!: number;
    columns?: ListDataVm_Column[] | undefined;
    rows?: ListDataVm_Row[] | undefined;
    searchBy?: string | undefined;
    listTips?: string | undefined;
    readable!: boolean;
    writable!: boolean;
    deletable!: boolean;
    approveRejectable!: boolean;
    submittable!: boolean;

    constructor(data?: IListDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.formGroupId = _data["formGroupId"];
            this.formGroupName = _data["formGroupName"];
            this.totalPage = _data["totalPage"];
            this.totalRecords = _data["totalRecords"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ListDataVm_Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ListDataVm_Row.fromJS(item));
            }
            this.searchBy = _data["searchBy"];
            this.listTips = _data["listTips"];
            this.readable = _data["readable"];
            this.writable = _data["writable"];
            this.deletable = _data["deletable"];
            this.approveRejectable = _data["approveRejectable"];
            this.submittable = _data["submittable"];
        }
    }

    static fromJS(data: any): ListDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new ListDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["formGroupId"] = this.formGroupId;
        data["formGroupName"] = this.formGroupName;
        data["totalPage"] = this.totalPage;
        data["totalRecords"] = this.totalRecords;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["searchBy"] = this.searchBy;
        data["listTips"] = this.listTips;
        data["readable"] = this.readable;
        data["writable"] = this.writable;
        data["deletable"] = this.deletable;
        data["approveRejectable"] = this.approveRejectable;
        data["submittable"] = this.submittable;
        return data; 
    }
}

export interface IListDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    totalPage: number;
    totalRecords: number;
    pageSize: number;
    columns?: ListDataVm_Column[] | undefined;
    rows?: ListDataVm_Row[] | undefined;
    searchBy?: string | undefined;
    listTips?: string | undefined;
    readable: boolean;
    writable: boolean;
    deletable: boolean;
    approveRejectable: boolean;
    submittable: boolean;
}

export class ListDataVm_Column implements IListDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enableFilter!: boolean;
    options?: ListDataVm_Column_Option[] | undefined;

    constructor(data?: IListDataVm_Column) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enableFilter = _data["enableFilter"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(ListDataVm_Column_Option.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDataVm_Column {
        data = typeof data === 'object' ? data : {};
        let result = new ListDataVm_Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enableFilter"] = this.enableFilter;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enableFilter: boolean;
    options?: ListDataVm_Column_Option[] | undefined;
}

export class ListDataVm_Column_Option implements IListDataVm_Column_Option {
    text?: string | undefined;
    value?: string | undefined;

    constructor(data?: IListDataVm_Column_Option) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ListDataVm_Column_Option {
        data = typeof data === 'object' ? data : {};
        let result = new ListDataVm_Column_Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data; 
    }
}

export interface IListDataVm_Column_Option {
    text?: string | undefined;
    value?: string | undefined;
}

export class ListDataVm_Row implements IListDataVm_Row {
    id?: string | undefined;
    itemArray?: string[] | undefined;
    status?: string | undefined;
    readable!: boolean;
    writable!: boolean;
    deletable!: boolean;
    approveRejectable!: boolean;
    submittable!: boolean;
    lastModifiedTime?: string | undefined;
    lastModifiedBy?: string | undefined;
    dataScopeIdList?: string[] | undefined;

    constructor(data?: IListDataVm_Row) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["itemArray"])) {
                this.itemArray = [] as any;
                for (let item of _data["itemArray"])
                    this.itemArray!.push(item);
            }
            this.status = _data["status"];
            this.readable = _data["readable"];
            this.writable = _data["writable"];
            this.deletable = _data["deletable"];
            this.approveRejectable = _data["approveRejectable"];
            this.submittable = _data["submittable"];
            this.lastModifiedTime = _data["lastModifiedTime"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            if (Array.isArray(_data["dataScopeIdList"])) {
                this.dataScopeIdList = [] as any;
                for (let item of _data["dataScopeIdList"])
                    this.dataScopeIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): ListDataVm_Row {
        data = typeof data === 'object' ? data : {};
        let result = new ListDataVm_Row();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.itemArray)) {
            data["itemArray"] = [];
            for (let item of this.itemArray)
                data["itemArray"].push(item);
        }
        data["status"] = this.status;
        data["readable"] = this.readable;
        data["writable"] = this.writable;
        data["deletable"] = this.deletable;
        data["approveRejectable"] = this.approveRejectable;
        data["submittable"] = this.submittable;
        data["lastModifiedTime"] = this.lastModifiedTime;
        data["lastModifiedBy"] = this.lastModifiedBy;
        if (Array.isArray(this.dataScopeIdList)) {
            data["dataScopeIdList"] = [];
            for (let item of this.dataScopeIdList)
                data["dataScopeIdList"].push(item);
        }
        return data; 
    }
}

export interface IListDataVm_Row {
    id?: string | undefined;
    itemArray?: string[] | undefined;
    status?: string | undefined;
    readable: boolean;
    writable: boolean;
    deletable: boolean;
    approveRejectable: boolean;
    submittable: boolean;
    lastModifiedTime?: string | undefined;
    lastModifiedBy?: string | undefined;
    dataScopeIdList?: string[] | undefined;
}

export class FormApproverModel implements IFormApproverModel {
    userId?: string | undefined;
    dataScopesList?: string[] | undefined;

    constructor(data?: IFormApproverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["dataScopesList"])) {
                this.dataScopesList = [] as any;
                for (let item of _data["dataScopesList"])
                    this.dataScopesList!.push(item);
            }
        }
    }

    static fromJS(data: any): FormApproverModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormApproverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.dataScopesList)) {
            data["dataScopesList"] = [];
            for (let item of this.dataScopesList)
                data["dataScopesList"].push(item);
        }
        return data; 
    }
}

export interface IFormApproverModel {
    userId?: string | undefined;
    dataScopesList?: string[] | undefined;
}

export class ListDeletedDataVm implements IListDeletedDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    columns?: ListDeletedDataVm_Column[] | undefined;
    rows?: ListDeletedDataVm_Row[] | undefined;
    totalPage!: number;
    totalRecords!: number;
    pageSize!: number;

    constructor(data?: IListDeletedDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.formGroupId = _data["formGroupId"];
            this.formGroupName = _data["formGroupName"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ListDeletedDataVm_Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ListDeletedDataVm_Row.fromJS(item));
            }
            this.totalPage = _data["totalPage"];
            this.totalRecords = _data["totalRecords"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ListDeletedDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new ListDeletedDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["formGroupId"] = this.formGroupId;
        data["formGroupName"] = this.formGroupName;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalPage"] = this.totalPage;
        data["totalRecords"] = this.totalRecords;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IListDeletedDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    columns?: ListDeletedDataVm_Column[] | undefined;
    rows?: ListDeletedDataVm_Row[] | undefined;
    totalPage: number;
    totalRecords: number;
    pageSize: number;
}

export class ListDeletedDataVm_Column implements IListDeletedDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IListDeletedDataVm_Column) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ListDeletedDataVm_Column {
        data = typeof data === 'object' ? data : {};
        let result = new ListDeletedDataVm_Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }
}

export interface IListDeletedDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class ListDeletedDataVm_Row implements IListDeletedDataVm_Row {
    id?: string | undefined;
    itemArray?: string[] | undefined;

    constructor(data?: IListDeletedDataVm_Row) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["itemArray"])) {
                this.itemArray = [] as any;
                for (let item of _data["itemArray"])
                    this.itemArray!.push(item);
            }
        }
    }

    static fromJS(data: any): ListDeletedDataVm_Row {
        data = typeof data === 'object' ? data : {};
        let result = new ListDeletedDataVm_Row();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.itemArray)) {
            data["itemArray"] = [];
            for (let item of this.itemArray)
                data["itemArray"].push(item);
        }
        return data; 
    }
}

export interface IListDeletedDataVm_Row {
    id?: string | undefined;
    itemArray?: string[] | undefined;
}

export class WorkFlowResultVM implements IWorkFlowResultVM {
    succeeded!: boolean;
    message?: string | undefined;

    constructor(data?: IWorkFlowResultVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WorkFlowResultVM {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowResultVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        return data; 
    }
}

export interface IWorkFlowResultVM {
    succeeded: boolean;
    message?: string | undefined;
}

export class GetByIdResponse implements IGetByIdResponse {
    fieldsResult?: any | undefined;
    builtInFields?: BuiltinFieldVM[] | undefined;

    constructor(data?: IGetByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldsResult = _data["fieldsResult"];
            if (Array.isArray(_data["builtInFields"])) {
                this.builtInFields = [] as any;
                for (let item of _data["builtInFields"])
                    this.builtInFields!.push(BuiltinFieldVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldsResult"] = this.fieldsResult;
        if (Array.isArray(this.builtInFields)) {
            data["builtInFields"] = [];
            for (let item of this.builtInFields)
                data["builtInFields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetByIdResponse {
    fieldsResult?: any | undefined;
    builtInFields?: BuiltinFieldVM[] | undefined;
}

export class BuiltinFieldVM implements IBuiltinFieldVM {
    builtInFieldLabel?: string | undefined;
    builtInFieldValue?: string | undefined;

    constructor(data?: IBuiltinFieldVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.builtInFieldLabel = _data["builtInFieldLabel"];
            this.builtInFieldValue = _data["builtInFieldValue"];
        }
    }

    static fromJS(data: any): BuiltinFieldVM {
        data = typeof data === 'object' ? data : {};
        let result = new BuiltinFieldVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["builtInFieldLabel"] = this.builtInFieldLabel;
        data["builtInFieldValue"] = this.builtInFieldValue;
        return data; 
    }
}

export interface IBuiltinFieldVM {
    builtInFieldLabel?: string | undefined;
    builtInFieldValue?: string | undefined;
}

export class CreateResponse implements ICreateResponse {
    id?: string | undefined;
    message?: string | undefined;
    succeed!: boolean;
    needDuplicatedConfirm!: boolean;

    constructor(data?: ICreateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.succeed = _data["succeed"];
            this.needDuplicatedConfirm = _data["needDuplicatedConfirm"];
        }
    }

    static fromJS(data: any): CreateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["succeed"] = this.succeed;
        data["needDuplicatedConfirm"] = this.needDuplicatedConfirm;
        return data; 
    }
}

export interface ICreateResponse {
    id?: string | undefined;
    message?: string | undefined;
    succeed: boolean;
    needDuplicatedConfirm: boolean;
}

export class UpsertResponse implements IUpsertResponse {
    id!: string;
    message?: string | undefined;
    succeed!: boolean;
    needDuplicatedConfirm!: boolean;

    constructor(data?: IUpsertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.succeed = _data["succeed"];
            this.needDuplicatedConfirm = _data["needDuplicatedConfirm"];
        }
    }

    static fromJS(data: any): UpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["succeed"] = this.succeed;
        data["needDuplicatedConfirm"] = this.needDuplicatedConfirm;
        return data; 
    }
}

export interface IUpsertResponse {
    id: string;
    message?: string | undefined;
    succeed: boolean;
    needDuplicatedConfirm: boolean;
}

export class DeleteDataVm implements IDeleteDataVm {
    succeeded!: boolean;
    id?: string | undefined;
    message?: string | undefined;

    constructor(data?: IDeleteDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["id"] = this.id;
        data["message"] = this.message;
        return data; 
    }
}

export interface IDeleteDataVm {
    succeeded: boolean;
    id?: string | undefined;
    message?: string | undefined;
}

export class BatchDeleteDataVm implements IBatchDeleteDataVm {
    succeeded!: boolean;
    id?: string | undefined;
    message?: string | undefined;

    constructor(data?: IBatchDeleteDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.id = _data["id"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BatchDeleteDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDeleteDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["id"] = this.id;
        data["message"] = this.message;
        return data; 
    }
}

export interface IBatchDeleteDataVm {
    succeeded: boolean;
    id?: string | undefined;
    message?: string | undefined;
}

export class ListAuditDataVm implements IListAuditDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    columns?: ListAuditDataVm_Column[] | undefined;
    rows?: ListAuditDataVm_Row[] | undefined;
    totalPage!: number;
    totalRecords!: number;
    pageSize!: number;

    constructor(data?: IListAuditDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.formGroupId = _data["formGroupId"];
            this.formGroupName = _data["formGroupName"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ListAuditDataVm_Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ListAuditDataVm_Row.fromJS(item));
            }
            this.totalPage = _data["totalPage"];
            this.totalRecords = _data["totalRecords"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ListAuditDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new ListAuditDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["formGroupId"] = this.formGroupId;
        data["formGroupName"] = this.formGroupName;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalPage"] = this.totalPage;
        data["totalRecords"] = this.totalRecords;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IListAuditDataVm {
    formId?: string | undefined;
    formName?: string | undefined;
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    columns?: ListAuditDataVm_Column[] | undefined;
    rows?: ListAuditDataVm_Row[] | undefined;
    totalPage: number;
    totalRecords: number;
    pageSize: number;
}

export class ListAuditDataVm_Column implements IListAuditDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IListAuditDataVm_Column) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ListAuditDataVm_Column {
        data = typeof data === 'object' ? data : {};
        let result = new ListAuditDataVm_Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data; 
    }
}

export interface IListAuditDataVm_Column {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export class ListAuditDataVm_Row implements IListAuditDataVm_Row {
    auditId?: string | undefined;
    id?: string | undefined;
    itemArray?: string[] | undefined;

    constructor(data?: IListAuditDataVm_Row) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditId = _data["auditId"];
            this.id = _data["id"];
            if (Array.isArray(_data["itemArray"])) {
                this.itemArray = [] as any;
                for (let item of _data["itemArray"])
                    this.itemArray!.push(item);
            }
        }
    }

    static fromJS(data: any): ListAuditDataVm_Row {
        data = typeof data === 'object' ? data : {};
        let result = new ListAuditDataVm_Row();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditId"] = this.auditId;
        data["id"] = this.id;
        if (Array.isArray(this.itemArray)) {
            data["itemArray"] = [];
            for (let item of this.itemArray)
                data["itemArray"].push(item);
        }
        return data; 
    }
}

export interface IListAuditDataVm_Row {
    auditId?: string | undefined;
    id?: string | undefined;
    itemArray?: string[] | undefined;
}

export class ImportRequestResultVM implements IImportRequestResultVM {
    succeeded!: boolean;
    message?: string | undefined;
    needDuplicatedConfirm!: boolean;

    constructor(data?: IImportRequestResultVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
            this.needDuplicatedConfirm = _data["needDuplicatedConfirm"];
        }
    }

    static fromJS(data: any): ImportRequestResultVM {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRequestResultVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        data["needDuplicatedConfirm"] = this.needDuplicatedConfirm;
        return data; 
    }
}

export interface IImportRequestResultVM {
    succeeded: boolean;
    message?: string | undefined;
    needDuplicatedConfirm: boolean;
}

export class UploadBase64 implements IUploadBase64 {
    formId?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    content?: string | undefined;
    userId?: string | undefined;

    constructor(data?: IUploadBase64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.content = _data["content"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UploadBase64 {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBase64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["content"] = this.content;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUploadBase64 {
    formId?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    content?: string | undefined;
    userId?: string | undefined;
}

export class AddDataCommentVM implements IAddDataCommentVM {
    succeeded!: boolean;
    message?: string | undefined;

    constructor(data?: IAddDataCommentVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddDataCommentVM {
        data = typeof data === 'object' ? data : {};
        let result = new AddDataCommentVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["message"] = this.message;
        return data; 
    }
}

export interface IAddDataCommentVM {
    succeeded: boolean;
    message?: string | undefined;
}

export class AddDataCommentRequest implements IAddDataCommentRequest {
    formId?: string | undefined;
    dataId?: string | undefined;
    comments?: FormDataComment[] | undefined;

    constructor(data?: IAddDataCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.dataId = _data["dataId"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(FormDataComment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddDataCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddDataCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["dataId"] = this.dataId;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddDataCommentRequest {
    formId?: string | undefined;
    dataId?: string | undefined;
    comments?: FormDataComment[] | undefined;
}

export class FormDataComment implements IFormDataComment {
    content?: string | undefined;
    datetime?: Date | undefined;
    userId?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IFormDataComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): FormDataComment {
        data = typeof data === 'object' ? data : {};
        let result = new FormDataComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IFormDataComment {
    content?: string | undefined;
    datetime?: Date | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
}

export class AadUserModel implements IAadUserModel {
    userId!: string;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    audience?: string | undefined;
    userName?: string | undefined;
    businessUnit?: string | undefined;
    email?: string | undefined;
    userPrincipalName?: string | undefined;

    constructor(data?: IAadUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.objectId = _data["objectId"];
            this.tenantId = _data["tenantId"];
            this.audience = _data["audience"];
            this.userName = _data["userName"];
            this.businessUnit = _data["businessUnit"];
            this.email = _data["email"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): AadUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AadUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["objectId"] = this.objectId;
        data["tenantId"] = this.tenantId;
        data["audience"] = this.audience;
        data["userName"] = this.userName;
        data["businessUnit"] = this.businessUnit;
        data["email"] = this.email;
        data["userPrincipalName"] = this.userPrincipalName;
        return data; 
    }
}

export interface IAadUserModel {
    userId: string;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    audience?: string | undefined;
    userName?: string | undefined;
    businessUnit?: string | undefined;
    email?: string | undefined;
    userPrincipalName?: string | undefined;
}

export class ProjectModel implements IProjectModel {
    projectId?: string | undefined;
    description?: string | undefined;
    owner?: string | undefined;
    administrators?: string[] | undefined;
    baseUtcOffsetHour!: number;
    dateTimeAbbreviation?: string | undefined;
    timeZoneId?: string | undefined;

    constructor(data?: IProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.owner = _data["owner"];
            if (Array.isArray(_data["administrators"])) {
                this.administrators = [] as any;
                for (let item of _data["administrators"])
                    this.administrators!.push(item);
            }
            this.baseUtcOffsetHour = _data["baseUtcOffsetHour"];
            this.dateTimeAbbreviation = _data["dateTimeAbbreviation"];
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): ProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["owner"] = this.owner;
        if (Array.isArray(this.administrators)) {
            data["administrators"] = [];
            for (let item of this.administrators)
                data["administrators"].push(item);
        }
        data["baseUtcOffsetHour"] = this.baseUtcOffsetHour;
        data["dateTimeAbbreviation"] = this.dateTimeAbbreviation;
        data["timeZoneId"] = this.timeZoneId;
        return data; 
    }
}

export interface IProjectModel {
    projectId?: string | undefined;
    description?: string | undefined;
    owner?: string | undefined;
    administrators?: string[] | undefined;
    baseUtcOffsetHour: number;
    dateTimeAbbreviation?: string | undefined;
    timeZoneId?: string | undefined;
}

export class ProjectAdministratorModel implements IProjectAdministratorModel {
    userId?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IProjectAdministratorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ProjectAdministratorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAdministratorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IProjectAdministratorModel {
    userId?: string | undefined;
    userName?: string | undefined;
}

export class ProjectFormModel implements IProjectFormModel {
    formGroupId?: string | undefined;
    formId?: string | undefined;
    formName?: string | undefined;
    dataScopes?: FormDataScopeModel[] | undefined;
    formGroupName?: string | undefined;
    order!: number;

    constructor(data?: IProjectFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formGroupId = _data["formGroupId"];
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            if (Array.isArray(_data["dataScopes"])) {
                this.dataScopes = [] as any;
                for (let item of _data["dataScopes"])
                    this.dataScopes!.push(FormDataScopeModel.fromJS(item));
            }
            this.formGroupName = _data["formGroupName"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ProjectFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formGroupId"] = this.formGroupId;
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        if (Array.isArray(this.dataScopes)) {
            data["dataScopes"] = [];
            for (let item of this.dataScopes)
                data["dataScopes"].push(item.toJSON());
        }
        data["formGroupName"] = this.formGroupName;
        data["order"] = this.order;
        return data; 
    }
}

export interface IProjectFormModel {
    formGroupId?: string | undefined;
    formId?: string | undefined;
    formName?: string | undefined;
    dataScopes?: FormDataScopeModel[] | undefined;
    formGroupName?: string | undefined;
    order: number;
}

export class FormDataScopeModel implements IFormDataScopeModel {
    formDataScopeId?: string | undefined;
    formDataScopeName?: string | undefined;
    formId?: string | undefined;
    formFieldId?: string | undefined;
    formFieldValue?: string | undefined;

    constructor(data?: IFormDataScopeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formDataScopeId = _data["formDataScopeId"];
            this.formDataScopeName = _data["formDataScopeName"];
            this.formId = _data["formId"];
            this.formFieldId = _data["formFieldId"];
            this.formFieldValue = _data["formFieldValue"];
        }
    }

    static fromJS(data: any): FormDataScopeModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormDataScopeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formDataScopeId"] = this.formDataScopeId;
        data["formDataScopeName"] = this.formDataScopeName;
        data["formId"] = this.formId;
        data["formFieldId"] = this.formFieldId;
        data["formFieldValue"] = this.formFieldValue;
        return data; 
    }
}

export interface IFormDataScopeModel {
    formDataScopeId?: string | undefined;
    formDataScopeName?: string | undefined;
    formId?: string | undefined;
    formFieldId?: string | undefined;
    formFieldValue?: string | undefined;
}

export class ProjectUserGroupModel implements IProjectUserGroupModel {
    userGroupId?: string | undefined;
    userGroupName?: string | undefined;
    description?: string | undefined;
    memberCount!: number;
    members?: SubjectModel[] | undefined;
    parents?: SubjectModel[] | undefined;
    ancestors?: SubjectModel[] | undefined;
    descendants?: SubjectModel[] | undefined;
    dataPermissions?: DataPermissionModel[] | undefined;

    constructor(data?: IProjectUserGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupId = _data["userGroupId"];
            this.userGroupName = _data["userGroupName"];
            this.description = _data["description"];
            this.memberCount = _data["memberCount"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SubjectModel.fromJS(item));
            }
            if (Array.isArray(_data["parents"])) {
                this.parents = [] as any;
                for (let item of _data["parents"])
                    this.parents!.push(SubjectModel.fromJS(item));
            }
            if (Array.isArray(_data["ancestors"])) {
                this.ancestors = [] as any;
                for (let item of _data["ancestors"])
                    this.ancestors!.push(SubjectModel.fromJS(item));
            }
            if (Array.isArray(_data["descendants"])) {
                this.descendants = [] as any;
                for (let item of _data["descendants"])
                    this.descendants!.push(SubjectModel.fromJS(item));
            }
            if (Array.isArray(_data["dataPermissions"])) {
                this.dataPermissions = [] as any;
                for (let item of _data["dataPermissions"])
                    this.dataPermissions!.push(DataPermissionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectUserGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupId"] = this.userGroupId;
        data["userGroupName"] = this.userGroupName;
        data["description"] = this.description;
        data["memberCount"] = this.memberCount;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.parents)) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        if (Array.isArray(this.ancestors)) {
            data["ancestors"] = [];
            for (let item of this.ancestors)
                data["ancestors"].push(item.toJSON());
        }
        if (Array.isArray(this.descendants)) {
            data["descendants"] = [];
            for (let item of this.descendants)
                data["descendants"].push(item.toJSON());
        }
        if (Array.isArray(this.dataPermissions)) {
            data["dataPermissions"] = [];
            for (let item of this.dataPermissions)
                data["dataPermissions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProjectUserGroupModel {
    userGroupId?: string | undefined;
    userGroupName?: string | undefined;
    description?: string | undefined;
    memberCount: number;
    members?: SubjectModel[] | undefined;
    parents?: SubjectModel[] | undefined;
    ancestors?: SubjectModel[] | undefined;
    descendants?: SubjectModel[] | undefined;
    dataPermissions?: DataPermissionModel[] | undefined;
}

export class SubjectModel implements ISubjectModel {
    projectId?: string | undefined;
    entityId?: string | undefined;
    type!: SubjectType;

    constructor(data?: ISubjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SubjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISubjectModel {
    projectId?: string | undefined;
    entityId?: string | undefined;
    type: SubjectType;
}

export enum SubjectType {
    UserGroup = 0,
    User = 1,
}

export class DataPermissionModel implements IDataPermissionModel {
    projectId?: string | undefined;
    formId?: string | undefined;
    formDataScopeId?: string | undefined;
    act!: ActIdModel;
    value!: PermissionValue;

    constructor(data?: IDataPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.formId = _data["formId"];
            this.formDataScopeId = _data["formDataScopeId"];
            this.act = _data["act"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["formId"] = this.formId;
        data["formDataScopeId"] = this.formDataScopeId;
        data["act"] = this.act;
        data["value"] = this.value;
        return data; 
    }
}

export interface IDataPermissionModel {
    projectId?: string | undefined;
    formId?: string | undefined;
    formDataScopeId?: string | undefined;
    act: ActIdModel;
    value: PermissionValue;
}

export enum ActIdModel {
    Read = 0,
    Write = 1,
    Delete = 2,
    AWSubmit = 3,
    AWApproveReject = 4,
    AWRetract = 5,
}

export enum PermissionValue {
    Allow = 0,
    Deny = 1,
    NotSet = 2,
}

export class UpdateDataPermissionsRequest implements IUpdateDataPermissionsRequest {
    projectId?: string | undefined;
    userGroupId?: string | undefined;
    permissionsToAdd?: DataPermissionModel[] | undefined;
    permissionsToRemove?: DataPermissionModel[] | undefined;

    constructor(data?: IUpdateDataPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.userGroupId = _data["userGroupId"];
            if (Array.isArray(_data["permissionsToAdd"])) {
                this.permissionsToAdd = [] as any;
                for (let item of _data["permissionsToAdd"])
                    this.permissionsToAdd!.push(DataPermissionModel.fromJS(item));
            }
            if (Array.isArray(_data["permissionsToRemove"])) {
                this.permissionsToRemove = [] as any;
                for (let item of _data["permissionsToRemove"])
                    this.permissionsToRemove!.push(DataPermissionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDataPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["userGroupId"] = this.userGroupId;
        if (Array.isArray(this.permissionsToAdd)) {
            data["permissionsToAdd"] = [];
            for (let item of this.permissionsToAdd)
                data["permissionsToAdd"].push(item.toJSON());
        }
        if (Array.isArray(this.permissionsToRemove)) {
            data["permissionsToRemove"] = [];
            for (let item of this.permissionsToRemove)
                data["permissionsToRemove"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateDataPermissionsRequest {
    projectId?: string | undefined;
    userGroupId?: string | undefined;
    permissionsToAdd?: DataPermissionModel[] | undefined;
    permissionsToRemove?: DataPermissionModel[] | undefined;
}

export class ProjectUserModel implements IProjectUserModel {
    userId?: string | undefined;

    constructor(data?: IProjectUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ProjectUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IProjectUserModel {
    userId?: string | undefined;
}

export class ProjectUserPermissionAuditTrailResponse implements IProjectUserPermissionAuditTrailResponse {
    userPermissionAuditTrails?: UserPermissionAuditTrailModel[] | undefined;
    totalPage!: number;
    totalRecords!: number;
    pageSize!: number;

    constructor(data?: IProjectUserPermissionAuditTrailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userPermissionAuditTrails"])) {
                this.userPermissionAuditTrails = [] as any;
                for (let item of _data["userPermissionAuditTrails"])
                    this.userPermissionAuditTrails!.push(UserPermissionAuditTrailModel.fromJS(item));
            }
            this.totalPage = _data["totalPage"];
            this.totalRecords = _data["totalRecords"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): ProjectUserPermissionAuditTrailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserPermissionAuditTrailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userPermissionAuditTrails)) {
            data["userPermissionAuditTrails"] = [];
            for (let item of this.userPermissionAuditTrails)
                data["userPermissionAuditTrails"].push(item.toJSON());
        }
        data["totalPage"] = this.totalPage;
        data["totalRecords"] = this.totalRecords;
        data["pageSize"] = this.pageSize;
        return data; 
    }
}

export interface IProjectUserPermissionAuditTrailResponse {
    userPermissionAuditTrails?: UserPermissionAuditTrailModel[] | undefined;
    totalPage: number;
    totalRecords: number;
    pageSize: number;
}

export class UserPermissionAuditTrailModel implements IUserPermissionAuditTrailModel {
    eventId?: string | undefined;
    projectId?: string | undefined;
    userId?: string | undefined;
    timestamp!: Date;
    timestampText?: string | undefined;
    action?: string | undefined;

    constructor(data?: IUserPermissionAuditTrailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.timestampText = _data["timestampText"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): UserPermissionAuditTrailModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionAuditTrailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["timestampText"] = this.timestampText;
        data["action"] = this.action;
        return data; 
    }
}

export interface IUserPermissionAuditTrailModel {
    eventId?: string | undefined;
    projectId?: string | undefined;
    userId?: string | undefined;
    timestamp: Date;
    timestampText?: string | undefined;
    action?: string | undefined;
}

export class TimeZoneModel implements ITimeZoneModel {
    baseUtcOffsetHour!: number;
    timeZoneId?: string | undefined;
    timeZone?: string | undefined;

    constructor(data?: ITimeZoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseUtcOffsetHour = _data["baseUtcOffsetHour"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): TimeZoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseUtcOffsetHour"] = this.baseUtcOffsetHour;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZone"] = this.timeZone;
        return data; 
    }
}

export interface ITimeZoneModel {
    baseUtcOffsetHour: number;
    timeZoneId?: string | undefined;
    timeZone?: string | undefined;
}

export class ListFormGroupsResponse implements IListFormGroupsResponse {
    value?: FormGroupModel[] | undefined;

    constructor(data?: IListFormGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(FormGroupModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListFormGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListFormGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListFormGroupsResponse {
    value?: FormGroupModel[] | undefined;
}

export class FormGroupModel implements IFormGroupModel {
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    order!: number;
    forms?: ListFormModel[] | undefined;

    constructor(data?: IFormGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formGroupId = _data["formGroupId"];
            this.formGroupName = _data["formGroupName"];
            this.order = _data["order"];
            if (Array.isArray(_data["forms"])) {
                this.forms = [] as any;
                for (let item of _data["forms"])
                    this.forms!.push(ListFormModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formGroupId"] = this.formGroupId;
        data["formGroupName"] = this.formGroupName;
        data["order"] = this.order;
        if (Array.isArray(this.forms)) {
            data["forms"] = [];
            for (let item of this.forms)
                data["forms"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFormGroupModel {
    formGroupId?: string | undefined;
    formGroupName?: string | undefined;
    order: number;
    forms?: ListFormModel[] | undefined;
}

export class ListFormModel implements IListFormModel {
    formId?: string | undefined;
    formName?: string | undefined;
    order!: number;
    needApprove!: boolean;

    constructor(data?: IListFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.order = _data["order"];
            this.needApprove = _data["needApprove"];
        }
    }

    static fromJS(data: any): ListFormModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListFormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["order"] = this.order;
        data["needApprove"] = this.needApprove;
        return data; 
    }
}

export interface IListFormModel {
    formId?: string | undefined;
    formName?: string | undefined;
    order: number;
    needApprove: boolean;
}

export class GetFormByIdResponse implements IGetFormByIdResponse {
    value?: FormModel | undefined;
    projectId?: string | undefined;
    isAdmin!: boolean;

    constructor(data?: IGetFormByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? FormModel.fromJS(_data["value"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): GetFormByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["isAdmin"] = this.isAdmin;
        return data; 
    }
}

export interface IGetFormByIdResponse {
    value?: FormModel | undefined;
    projectId?: string | undefined;
    isAdmin: boolean;
}

export class FormModel implements IFormModel {
    formId?: string | undefined;
    formName?: string | undefined;
    description?: string | undefined;
    order!: number;
    formGroupId?: string | undefined;
    style?: string | undefined;
    fields?: FormFieldModel[] | undefined;
    templateUrl?: string | undefined;
    importOnly!: boolean;
    isSoftDeleted!: boolean;
    isTriggerWhenDelete!: boolean;
    isTriggerWhenEdit!: boolean;
    isTriggerWhenCovered!: boolean;
    isRemoveNeedlessColumn!: boolean;
    enableAudit!: boolean;
    hideTemplateUrl!: boolean;
    needApprove!: boolean;
    enableApproveRejectWithComments!: boolean;
    hideImport!: boolean;
    hideExport!: boolean;
    hideManualCreate!: boolean;
    withoutComments!: boolean;
    hideActions!: boolean;
    enableSearch!: boolean;
    detailFormID?: string | undefined;
    enableSorting!: boolean;
    enableFilter!: boolean;
    listTips?: string | undefined;
    creationTips?: string | undefined;
    pageSize!: number;
    showLastBatch!: boolean;
    enableApproveByBU!: boolean;
    enableAccessByBU!: boolean;
    buFieldId?: string | undefined;
    defaultOrderById?: string | undefined;
    enableExportData!: boolean;
    importWarningMessage?: string | undefined;
    overwriteWarningMessage?: string | undefined;
    showHistoryInDetails!: boolean;
    showBuiltInFieldsInDetails!: boolean;
    showSaveSubmitInCreate!: boolean;
    dataScopes?: FormDataScopeModel[] | undefined;
    enableApproverSelection!: boolean;

    constructor(data?: IFormModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.formGroupId = _data["formGroupId"];
            this.style = _data["style"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FormFieldModel.fromJS(item));
            }
            this.templateUrl = _data["templateUrl"];
            this.importOnly = _data["importOnly"];
            this.isSoftDeleted = _data["isSoftDeleted"];
            this.isTriggerWhenDelete = _data["isTriggerWhenDelete"];
            this.isTriggerWhenEdit = _data["isTriggerWhenEdit"];
            this.isTriggerWhenCovered = _data["isTriggerWhenCovered"];
            this.isRemoveNeedlessColumn = _data["isRemoveNeedlessColumn"];
            this.enableAudit = _data["enableAudit"];
            this.hideTemplateUrl = _data["hideTemplateUrl"];
            this.needApprove = _data["needApprove"];
            this.enableApproveRejectWithComments = _data["enableApproveRejectWithComments"];
            this.hideImport = _data["hideImport"];
            this.hideExport = _data["hideExport"];
            this.hideManualCreate = _data["hideManualCreate"];
            this.withoutComments = _data["withoutComments"];
            this.hideActions = _data["hideActions"];
            this.enableSearch = _data["enableSearch"];
            this.detailFormID = _data["detailFormID"];
            this.enableSorting = _data["enableSorting"];
            this.enableFilter = _data["enableFilter"];
            this.listTips = _data["listTips"];
            this.creationTips = _data["creationTips"];
            this.pageSize = _data["pageSize"];
            this.showLastBatch = _data["showLastBatch"];
            this.enableApproveByBU = _data["enableApproveByBU"];
            this.enableAccessByBU = _data["enableAccessByBU"];
            this.buFieldId = _data["buFieldId"];
            this.defaultOrderById = _data["defaultOrderById"];
            this.enableExportData = _data["enableExportData"];
            this.importWarningMessage = _data["importWarningMessage"];
            this.overwriteWarningMessage = _data["overwriteWarningMessage"];
            this.showHistoryInDetails = _data["showHistoryInDetails"];
            this.showBuiltInFieldsInDetails = _data["showBuiltInFieldsInDetails"];
            this.showSaveSubmitInCreate = _data["showSaveSubmitInCreate"];
            if (Array.isArray(_data["dataScopes"])) {
                this.dataScopes = [] as any;
                for (let item of _data["dataScopes"])
                    this.dataScopes!.push(FormDataScopeModel.fromJS(item));
            }
            this.enableApproverSelection = _data["enableApproverSelection"];
        }
    }

    static fromJS(data: any): FormModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["description"] = this.description;
        data["order"] = this.order;
        data["formGroupId"] = this.formGroupId;
        data["style"] = this.style;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["templateUrl"] = this.templateUrl;
        data["importOnly"] = this.importOnly;
        data["isSoftDeleted"] = this.isSoftDeleted;
        data["isTriggerWhenDelete"] = this.isTriggerWhenDelete;
        data["isTriggerWhenEdit"] = this.isTriggerWhenEdit;
        data["isTriggerWhenCovered"] = this.isTriggerWhenCovered;
        data["isRemoveNeedlessColumn"] = this.isRemoveNeedlessColumn;
        data["enableAudit"] = this.enableAudit;
        data["hideTemplateUrl"] = this.hideTemplateUrl;
        data["needApprove"] = this.needApprove;
        data["enableApproveRejectWithComments"] = this.enableApproveRejectWithComments;
        data["hideImport"] = this.hideImport;
        data["hideExport"] = this.hideExport;
        data["hideManualCreate"] = this.hideManualCreate;
        data["withoutComments"] = this.withoutComments;
        data["hideActions"] = this.hideActions;
        data["enableSearch"] = this.enableSearch;
        data["detailFormID"] = this.detailFormID;
        data["enableSorting"] = this.enableSorting;
        data["enableFilter"] = this.enableFilter;
        data["listTips"] = this.listTips;
        data["creationTips"] = this.creationTips;
        data["pageSize"] = this.pageSize;
        data["showLastBatch"] = this.showLastBatch;
        data["enableApproveByBU"] = this.enableApproveByBU;
        data["enableAccessByBU"] = this.enableAccessByBU;
        data["buFieldId"] = this.buFieldId;
        data["defaultOrderById"] = this.defaultOrderById;
        data["enableExportData"] = this.enableExportData;
        data["importWarningMessage"] = this.importWarningMessage;
        data["overwriteWarningMessage"] = this.overwriteWarningMessage;
        data["showHistoryInDetails"] = this.showHistoryInDetails;
        data["showBuiltInFieldsInDetails"] = this.showBuiltInFieldsInDetails;
        data["showSaveSubmitInCreate"] = this.showSaveSubmitInCreate;
        if (Array.isArray(this.dataScopes)) {
            data["dataScopes"] = [];
            for (let item of this.dataScopes)
                data["dataScopes"].push(item.toJSON());
        }
        data["enableApproverSelection"] = this.enableApproverSelection;
        return data; 
    }
}

export interface IFormModel {
    formId?: string | undefined;
    formName?: string | undefined;
    description?: string | undefined;
    order: number;
    formGroupId?: string | undefined;
    style?: string | undefined;
    fields?: FormFieldModel[] | undefined;
    templateUrl?: string | undefined;
    importOnly: boolean;
    isSoftDeleted: boolean;
    isTriggerWhenDelete: boolean;
    isTriggerWhenEdit: boolean;
    isTriggerWhenCovered: boolean;
    isRemoveNeedlessColumn: boolean;
    enableAudit: boolean;
    hideTemplateUrl: boolean;
    needApprove: boolean;
    enableApproveRejectWithComments: boolean;
    hideImport: boolean;
    hideExport: boolean;
    hideManualCreate: boolean;
    withoutComments: boolean;
    hideActions: boolean;
    enableSearch: boolean;
    detailFormID?: string | undefined;
    enableSorting: boolean;
    enableFilter: boolean;
    listTips?: string | undefined;
    creationTips?: string | undefined;
    pageSize: number;
    showLastBatch: boolean;
    enableApproveByBU: boolean;
    enableAccessByBU: boolean;
    buFieldId?: string | undefined;
    defaultOrderById?: string | undefined;
    enableExportData: boolean;
    importWarningMessage?: string | undefined;
    overwriteWarningMessage?: string | undefined;
    showHistoryInDetails: boolean;
    showBuiltInFieldsInDetails: boolean;
    showSaveSubmitInCreate: boolean;
    dataScopes?: FormDataScopeModel[] | undefined;
    enableApproverSelection: boolean;
}

export class FormFieldModel implements IFormFieldModel {
    formFieldId?: string | undefined;
    formFieldName?: string | undefined;
    formId?: string | undefined;
    listColumnHeader?: string | undefined;
    listVisible!: boolean;
    listOrder!: number;
    label?: string | undefined;
    description?: string | undefined;
    order!: number;
    isBuiltIn!: boolean;
    defaultValue?: string | undefined;
    options?: FormFieldOptionModel[] | undefined;
    optionsReferencedFieldId?: string | undefined;
    controlType?: string | undefined;
    disabled!: boolean;
    createDisabled!: boolean;
    disabledReferencedFieldId?: string | undefined;
    disabledReferencedFieldValue?: string | undefined;
    createHidden!: boolean;
    hidden!: boolean;
    hiddenReferencedFieldId?: string | undefined;
    hiddenReferencedFieldValue?: string | undefined;
    clearInputWhenHidden!: boolean;
    displayReferencedFieldId?: string | undefined;
    displayReferencedFieldValue?: string | undefined;
    requiredReferencedFieldId?: string | undefined;
    requiredReferencedFieldValue?: string | undefined;
    clearInputWhenDisabled!: boolean;
    style?: string | undefined;
    dataFormat?: string | undefined;
    valueType?: string | undefined;
    required!: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
    stringMinLength?: number | undefined;
    stringMaxLength?: number | undefined;
    validationPattern?: string | undefined;
    validationErrorMessage?: string | undefined;
    validationWarningPattern?: string | undefined;
    validationWarningMessage?: string | undefined;
    enableFilter!: boolean;
    filterOptions?: string[] | undefined;
    enableSort!: boolean;
    alternativeIds?: string[] | undefined;
    key!: boolean;
    enableSearch!: boolean;
    detailFormID?: string | undefined;
    detailWriteToFieldIDs?: string | undefined;
    importIgnore!: boolean;
    comparedWith?: string | undefined;
    comparedOperator?: string | undefined;
    comparedErrorMessage?: string | undefined;
    optionsSource?: OptionsSource | undefined;

    constructor(data?: IFormFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldId = _data["formFieldId"];
            this.formFieldName = _data["formFieldName"];
            this.formId = _data["formId"];
            this.listColumnHeader = _data["listColumnHeader"];
            this.listVisible = _data["listVisible"];
            this.listOrder = _data["listOrder"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.isBuiltIn = _data["isBuiltIn"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FormFieldOptionModel.fromJS(item));
            }
            this.optionsReferencedFieldId = _data["optionsReferencedFieldId"];
            this.controlType = _data["controlType"];
            this.disabled = _data["disabled"];
            this.createDisabled = _data["createDisabled"];
            this.disabledReferencedFieldId = _data["disabledReferencedFieldId"];
            this.disabledReferencedFieldValue = _data["disabledReferencedFieldValue"];
            this.createHidden = _data["createHidden"];
            this.hidden = _data["hidden"];
            this.hiddenReferencedFieldId = _data["hiddenReferencedFieldId"];
            this.hiddenReferencedFieldValue = _data["hiddenReferencedFieldValue"];
            this.clearInputWhenHidden = _data["clearInputWhenHidden"];
            this.displayReferencedFieldId = _data["displayReferencedFieldId"];
            this.displayReferencedFieldValue = _data["displayReferencedFieldValue"];
            this.requiredReferencedFieldId = _data["requiredReferencedFieldId"];
            this.requiredReferencedFieldValue = _data["requiredReferencedFieldValue"];
            this.clearInputWhenDisabled = _data["clearInputWhenDisabled"];
            this.style = _data["style"];
            this.dataFormat = _data["dataFormat"];
            this.valueType = _data["valueType"];
            this.required = _data["required"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.minDate = _data["minDate"] ? new Date(_data["minDate"].toString()) : <any>undefined;
            this.maxDate = _data["maxDate"] ? new Date(_data["maxDate"].toString()) : <any>undefined;
            this.stringMinLength = _data["stringMinLength"];
            this.stringMaxLength = _data["stringMaxLength"];
            this.validationPattern = _data["validationPattern"];
            this.validationErrorMessage = _data["validationErrorMessage"];
            this.validationWarningPattern = _data["validationWarningPattern"];
            this.validationWarningMessage = _data["validationWarningMessage"];
            this.enableFilter = _data["enableFilter"];
            if (Array.isArray(_data["filterOptions"])) {
                this.filterOptions = [] as any;
                for (let item of _data["filterOptions"])
                    this.filterOptions!.push(item);
            }
            this.enableSort = _data["enableSort"];
            if (Array.isArray(_data["alternativeIds"])) {
                this.alternativeIds = [] as any;
                for (let item of _data["alternativeIds"])
                    this.alternativeIds!.push(item);
            }
            this.key = _data["key"];
            this.enableSearch = _data["enableSearch"];
            this.detailFormID = _data["detailFormID"];
            this.detailWriteToFieldIDs = _data["detailWriteToFieldIDs"];
            this.importIgnore = _data["importIgnore"];
            this.comparedWith = _data["comparedWith"];
            this.comparedOperator = _data["comparedOperator"];
            this.comparedErrorMessage = _data["comparedErrorMessage"];
            this.optionsSource = _data["optionsSource"] ? OptionsSource.fromJS(_data["optionsSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldId"] = this.formFieldId;
        data["formFieldName"] = this.formFieldName;
        data["formId"] = this.formId;
        data["listColumnHeader"] = this.listColumnHeader;
        data["listVisible"] = this.listVisible;
        data["listOrder"] = this.listOrder;
        data["label"] = this.label;
        data["description"] = this.description;
        data["order"] = this.order;
        data["isBuiltIn"] = this.isBuiltIn;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["optionsReferencedFieldId"] = this.optionsReferencedFieldId;
        data["controlType"] = this.controlType;
        data["disabled"] = this.disabled;
        data["createDisabled"] = this.createDisabled;
        data["disabledReferencedFieldId"] = this.disabledReferencedFieldId;
        data["disabledReferencedFieldValue"] = this.disabledReferencedFieldValue;
        data["createHidden"] = this.createHidden;
        data["hidden"] = this.hidden;
        data["hiddenReferencedFieldId"] = this.hiddenReferencedFieldId;
        data["hiddenReferencedFieldValue"] = this.hiddenReferencedFieldValue;
        data["clearInputWhenHidden"] = this.clearInputWhenHidden;
        data["displayReferencedFieldId"] = this.displayReferencedFieldId;
        data["displayReferencedFieldValue"] = this.displayReferencedFieldValue;
        data["requiredReferencedFieldId"] = this.requiredReferencedFieldId;
        data["requiredReferencedFieldValue"] = this.requiredReferencedFieldValue;
        data["clearInputWhenDisabled"] = this.clearInputWhenDisabled;
        data["style"] = this.style;
        data["dataFormat"] = this.dataFormat;
        data["valueType"] = this.valueType;
        data["required"] = this.required;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["minDate"] = this.minDate ? this.minDate.toISOString() : <any>undefined;
        data["maxDate"] = this.maxDate ? this.maxDate.toISOString() : <any>undefined;
        data["stringMinLength"] = this.stringMinLength;
        data["stringMaxLength"] = this.stringMaxLength;
        data["validationPattern"] = this.validationPattern;
        data["validationErrorMessage"] = this.validationErrorMessage;
        data["validationWarningPattern"] = this.validationWarningPattern;
        data["validationWarningMessage"] = this.validationWarningMessage;
        data["enableFilter"] = this.enableFilter;
        if (Array.isArray(this.filterOptions)) {
            data["filterOptions"] = [];
            for (let item of this.filterOptions)
                data["filterOptions"].push(item);
        }
        data["enableSort"] = this.enableSort;
        if (Array.isArray(this.alternativeIds)) {
            data["alternativeIds"] = [];
            for (let item of this.alternativeIds)
                data["alternativeIds"].push(item);
        }
        data["key"] = this.key;
        data["enableSearch"] = this.enableSearch;
        data["detailFormID"] = this.detailFormID;
        data["detailWriteToFieldIDs"] = this.detailWriteToFieldIDs;
        data["importIgnore"] = this.importIgnore;
        data["comparedWith"] = this.comparedWith;
        data["comparedOperator"] = this.comparedOperator;
        data["comparedErrorMessage"] = this.comparedErrorMessage;
        data["optionsSource"] = this.optionsSource ? this.optionsSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFormFieldModel {
    formFieldId?: string | undefined;
    formFieldName?: string | undefined;
    formId?: string | undefined;
    listColumnHeader?: string | undefined;
    listVisible: boolean;
    listOrder: number;
    label?: string | undefined;
    description?: string | undefined;
    order: number;
    isBuiltIn: boolean;
    defaultValue?: string | undefined;
    options?: FormFieldOptionModel[] | undefined;
    optionsReferencedFieldId?: string | undefined;
    controlType?: string | undefined;
    disabled: boolean;
    createDisabled: boolean;
    disabledReferencedFieldId?: string | undefined;
    disabledReferencedFieldValue?: string | undefined;
    createHidden: boolean;
    hidden: boolean;
    hiddenReferencedFieldId?: string | undefined;
    hiddenReferencedFieldValue?: string | undefined;
    clearInputWhenHidden: boolean;
    displayReferencedFieldId?: string | undefined;
    displayReferencedFieldValue?: string | undefined;
    requiredReferencedFieldId?: string | undefined;
    requiredReferencedFieldValue?: string | undefined;
    clearInputWhenDisabled: boolean;
    style?: string | undefined;
    dataFormat?: string | undefined;
    valueType?: string | undefined;
    required: boolean;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minDate?: Date | undefined;
    maxDate?: Date | undefined;
    stringMinLength?: number | undefined;
    stringMaxLength?: number | undefined;
    validationPattern?: string | undefined;
    validationErrorMessage?: string | undefined;
    validationWarningPattern?: string | undefined;
    validationWarningMessage?: string | undefined;
    enableFilter: boolean;
    filterOptions?: string[] | undefined;
    enableSort: boolean;
    alternativeIds?: string[] | undefined;
    key: boolean;
    enableSearch: boolean;
    detailFormID?: string | undefined;
    detailWriteToFieldIDs?: string | undefined;
    importIgnore: boolean;
    comparedWith?: string | undefined;
    comparedOperator?: string | undefined;
    comparedErrorMessage?: string | undefined;
    optionsSource?: OptionsSource | undefined;
}

export class FormFieldOptionModel implements IFormFieldOptionModel {
    value?: string | undefined;
    name?: string | undefined;
    referencedFieldValue?: string | undefined;

    constructor(data?: IFormFieldOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.referencedFieldValue = _data["referencedFieldValue"];
        }
    }

    static fromJS(data: any): FormFieldOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["referencedFieldValue"] = this.referencedFieldValue;
        return data; 
    }
}

export interface IFormFieldOptionModel {
    value?: string | undefined;
    name?: string | undefined;
    referencedFieldValue?: string | undefined;
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IValueObject {
}

export class OptionsSource extends ValueObject implements IOptionsSource {
    source?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    referencedFieldValue?: string | undefined;

    constructor(data?: IOptionsSource) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.source = _data["source"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.referencedFieldValue = _data["referencedFieldValue"];
        }
    }

    static fromJS(data: any): OptionsSource {
        data = typeof data === 'object' ? data : {};
        let result = new OptionsSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["id"] = this.id;
        data["name"] = this.name;
        data["referencedFieldValue"] = this.referencedFieldValue;
        super.toJSON(data);
        return data; 
    }
}

export interface IOptionsSource extends IValueObject {
    source?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    referencedFieldValue?: string | undefined;
}

export class UpsertFormResponse implements IUpsertFormResponse {
    succeeded!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpsertFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpsertFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IUpsertFormResponse {
    succeeded: boolean;
    errorMessage?: string | undefined;
}

export class DeleteFormResponse implements IDeleteFormResponse {
    succeeded!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IDeleteFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): DeleteFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IDeleteFormResponse {
    succeeded: boolean;
    errorMessage?: string | undefined;
}

export class UpdateFormResponse implements IUpdateFormResponse {
    succeeded!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateFormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IUpdateFormResponse {
    succeeded: boolean;
    errorMessage?: string | undefined;
}

export class FormDetailsModel implements IFormDetailsModel {
    formId?: string | undefined;
    formName?: string | undefined;
    listTips?: string | undefined;
    creationTips?: string | undefined;
    importWarningMessage?: string | undefined;
    formDescription?: string | undefined;
    fields?: FormDetailsFieldModel[] | undefined;

    constructor(data?: IFormDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.listTips = _data["listTips"];
            this.creationTips = _data["creationTips"];
            this.importWarningMessage = _data["importWarningMessage"];
            this.formDescription = _data["formDescription"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FormDetailsFieldModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["listTips"] = this.listTips;
        data["creationTips"] = this.creationTips;
        data["importWarningMessage"] = this.importWarningMessage;
        data["formDescription"] = this.formDescription;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFormDetailsModel {
    formId?: string | undefined;
    formName?: string | undefined;
    listTips?: string | undefined;
    creationTips?: string | undefined;
    importWarningMessage?: string | undefined;
    formDescription?: string | undefined;
    fields?: FormDetailsFieldModel[] | undefined;
}

export class FormDetailsFieldModel implements IFormDetailsFieldModel {
    formFieldId?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;

    constructor(data?: IFormDetailsFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldId = _data["formFieldId"];
            this.description = _data["description"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): FormDetailsFieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormDetailsFieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldId"] = this.formFieldId;
        data["description"] = this.description;
        data["label"] = this.label;
        return data; 
    }
}

export interface IFormDetailsFieldModel {
    formFieldId?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}